import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import logo from "../assets/images/logo.png";
import { useTranslation } from "../contexts/TranslationContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function Navbar() {
  const [activeLink, setActiveLink] = useState("/");
  const { t, toggleLanguage, language, isRTL } = useTranslation();

  const links = [
    { name: t("navigation.home"), path: "home" },
    { name: t("navigation.about"), path: "about" },
    { name: t("navigation.services"), path: "services" },
    { name: "How it works", path: "how_it_works" },
    { name:  "Why Choose Us", path: "hy_wchoose_us" },
    // { name: t("navigation.download"), path: "downloadApp" },
  ];

  return (
    <>
      <nav className="navbar navbar-expand-lg px-5" id="home" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="container-fluid d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="Logo" className="logo" />
          </Link>

          {/* Nav Links */}
          <div className="collapse navbar-collapse justify-content-center d-none d-lg-flex">
            <ul className="navbar-nav gap-4">
              {links.map((l) => (
                <li
                  className="nav-item d-flex flex-column align-items-center"
                  key={l.path}
                >
                  <Link
                    to={`/#${l.path}`}
                    className={`nav-link mt-2 ${
                      activeLink === l.path ? "active" : ""
                    }`}
                    onClick={() => setActiveLink(l.path)}
                  >
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
{/* 
          <div className="d-none d-lg-block">
            <button 
              className="btn rounded-2 contact-btn"
              onClick={toggleLanguage}
            >
              {language === 'eng' ? t("buttons.arabic") : t("buttons.english")}
            </button>
          </div> */}

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </div>
      </nav>

      {/* ───── OFF-CANVAS (mobile only) ───── */}
      <div
        className="offcanvas offcanvas-start d-lg-none"
        id="offcanvasNavbar"
        tabIndex="-1"
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title mb-0">
            <img src={logo} alt="Logo" className="logo" />
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>

        <div className="offcanvas-body">
          <ul className="navbar-nav gap-3">
            {links.map((l) => (
              <li
                className="nav-item d-flex flex-column align-items-start"
                key={l.path}
              >
                <ScrollLink
                  style={{ fontSize: "1.125rem" }}
                  to={l.path}
                  smooth
                  duration={200}
                  spy
                  className={`nav-link ${
                    activeLink === l.path ? "active" : ""
                  }`}
                  onClick={() => setActiveLink(l.path)}
                  data-bs-dismiss="offcanvas"
                >
                  {l.name}
                </ScrollLink>
              </li>
            ))}
          </ul>

          <div className="mt-4">
            <button 
              className="btn rounded-2 contact-btn"
              onClick={toggleLanguage}
            >
              {language === 'eng' ? t("buttons.arabic") : t("buttons.english")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
